/**
 * Converts a Supabase Storage public URL to use the Image Transformation API.
 *
 * Original:    /storage/v1/object/public/<bucket>/<path>
 * Transformed: /storage/v1/render/image/public/<bucket>/<path>?width=…&height=…
 *
 * Falls back to the original URL if the pattern doesn't match (e.g. external URLs).
 */
export function supabaseImageUrl(
  url: string | null | undefined,
  options: { width: number; height?: number; quality?: number },
): string | undefined {
  if (!url) return undefined;

  const transformed = url.replace(
    "/storage/v1/object/public/",
    "/storage/v1/render/image/public/",
  );

  // If the URL didn't match the Supabase pattern, return as-is
  if (transformed === url) return url;

  const params = new URLSearchParams();
  params.set("width", String(options.width));
  if (options.height) params.set("height", String(options.height));
  params.set("resize", "cover");
  params.set("quality", String(options.quality ?? 80));

  const separator = transformed.includes("?") ? "&" : "?";
  return `${transformed}${separator}${params.toString()}`;
}
